import { createSlice } from '@reduxjs/toolkit'
import { IGrant } from '../../types/Grants/Grant'
import {
  createShareableGrantAsyncBuilder,
  createShareableGrantsAsync,
  createShareableGrantsAsyncBuilder,
  createShareableGrantAsync
} from './asyncRequests'
import { InitialState } from './utils'

const initialState: InitialState = {
  loading: false,
  paging: {
    totalRows: 0,
    limit: 25,
    skip: 0,
    rows: 0,
    paging: true,
  },
  filters: {
    agencies: [],
    phases: [],
    statuses: ['open','forecasted'],
    dates: {
      startDate: null,
      endDate: null,
    },
  },
  data: [] as IGrant[],
  error: '',
}

const GrantsSlice = createSlice({
  name: 'Grants',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      }
    },
    setPaging: (state, action) => {
      const {
        limit = state.paging.limit,
        skip = state.paging.skip,
        paging = state.paging.paging,
      } = action.payload
      state.paging = { ...state.paging, skip, limit, paging }
    },

    resetPaging: (state) => {
      state.paging = initialState.paging
    },

    resetGrants: (state) => {
      state.data = initialState.data
    },
  },
  extraReducers: (builder) => {
    createShareableGrantAsyncBuilder(builder)
    createShareableGrantsAsyncBuilder(builder)
  },
})

export const GrantsActions = {
  ...GrantsSlice.actions,
  createShareableGrantsAsync,
  createShareableGrantAsync,
}

export const GrantsReducer = GrantsSlice.reducer
